module.exports = __webpack_public_path__ + "img/finish.5337f21a.svg";